import { atom } from "jotai";
import type {
    ProductSuggestion,
    ProductSuggestionsStatus,
} from "@models/productSuggestion";

// Product rows for the search autocomplete (#227). Held in an atom, like the facets, so a new
// query can keep the previous rows on screen while its own request is in flight instead of
// flashing the section empty between keystrokes.
export const productSuggestionsAtom = atom<ProductSuggestion[]>([]);

// The read's OUTCOME, which the payload above cannot express: an empty [] from a successful read
// and a failed read both leave the payload empty, and the Products section renders them
// differently (absent vs "Couldn't load products"). See ProductSuggestionsStatus.
export const productSuggestionsStatusAtom =
    atom<ProductSuggestionsStatus>("idle");
